<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户编号</label>
            <em class="weui-form-preview__value">{{ form.main.cu_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="cu_name" :key="'cu_name'">
            <label class="weui-form-preview__label">{{customLabel.cu_name || "客户名称"}}</label>
            <div class="weui-form-preview__value weui-form-preview__value-icon">
              <span>{{ form.main.cu_name }}</span>
              <router-link :to="{path:'/ent/Information',query:{name:form.main.cu_name}}" class="iconfont icon-qichacha"></router-link>
            </div>
          </div>
          <div class="weui-form-preview__item" slot="cu_type" :key="'cu_type'">
            <label class="weui-form-preview__label">{{customLabel.cu_type || "客户类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_nsrzh" slot="cu_nsrzh" :key="'cu_nsrzh'">
            <label class="weui-form-preview__label">{{customLabel.cu_nsrzh || "社会信用代码"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_nsrzh
            }}</span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_bankaccount" slot="cu_bankaccount" :key="'cu_bankaccount'">
            <label class="weui-form-preview__label">{{customLabel.cu_bankaccount || "开户行"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_bankaccount
            }}</span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_bankcode" slot="cu_bankcode" :key="'cu_bankcode'">
            <label class="weui-form-preview__label">{{customLabel.cu_bankcode || "开户账号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_bankcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_invoiceinfo" slot="cu_invoiceinfo" :key="'cu_invoiceinfo'">
            <label class="weui-form-preview__label">{{customLabel.cu_invoiceinfo || "开票地址"}}</label>
            <span
              class="weui-form-preview__value"
              :class="{
                'weui-form-preview__value-icon': !!form.main.cu_invoiceinfo,
              }"
            >
              {{ form.main.cu_invoiceinfo }}
              <router-link
                v-if="form.main.cu_invoiceinfo"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + form.main.cu_invoiceinfo"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_industry" slot="cu_industry" :key="'cu_industry'">
            <label class="weui-form-preview__label">{{customLabel.cu_industry || "行业类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_industry
            }}</span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_source" slot="cu_source" :key="'cu_source'">
            <label class="weui-form-preview__label">{{customLabel.cu_source || "商机线索"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_source
            }}</span>
          </div>
         
          <div class="weui-form-preview__item" slot="cu_taxrate" :key="'cu_taxrate'">
            <label class="weui-form-preview__label">{{customLabel.cu_taxrate || "税率(%)"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_taxrate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_credit" :key="'cu_credit'">
            <label class="weui-form-preview__label">{{customLabel.cu_credit || "信用额度(元)"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.cu_credit,'¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_credit_t" :key="'cu_credit_t'">
            <label class="weui-form-preview__label">{{customLabel.cu_credit_t || "临时信用额度(元)"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ numberFormat(form.main.cu_credit_t,'¥#,##0.00') }}
              <i v-if="form.main.cu_audit_status_code=='AUDITED'" class="iconfont icon-change" @click="applyTempCredit()">申请</i>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_payments" :key="'cu_payments'">
            <label class="weui-form-preview__label">{{customLabel.cu_payments || "收款方式"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.cu_payments }}
              <span v-if="form.main.cu_currency">{{
                form.main.cu_currency
              }}</span>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_paydelay" :key="'cu_paydelay'">
            <label class="weui-form-preview__label">{{customLabel.cu_paydelay || "收款延迟天数"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.cu_paydelay }}
             天
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_payments1" :key="'cu_payments1'">
            <label class="weui-form-preview__label">{{customLabel.cu_payments1 || "收款方式1"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.cu_payments1 }}
              <span v-if="form.main.cu_currency">{{
                form.main.cu_currency
              }}</span>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_paydelay1" :key="'cu_paydelay1'">
            <label class="weui-form-preview__label">{{customLabel.cu_paydelay1 || "收款延迟天数1"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.cu_paydelay1 }}
             天
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_payments2" :key="'cu_payments2'">
            <label class="weui-form-preview__label">{{customLabel.cu_payments2 || "收款方式2"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.cu_payments2 }}
              <span v-if="form.main.cu_currency">{{
                form.main.cu_currency
              }}</span>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_paydelay2" :key="'cu_paydelay2'">
            <label class="weui-form-preview__label">{{customLabel.cu_paydelay2 || "收款延迟天数2"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.cu_paydelay2 }}
             天
            </span>
          </div>
         
          <div class="weui-form-preview__item" :hidden="!form.main.cu_sellername" slot="cu_sellername" :key="'cu_sellername'">
            <label class="weui-form-preview__label">{{customLabel.cu_sellername || "业务员"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.cu_sellername }}
              <call-mobile :em-id="form.main.cu_sellerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_othersellers" slot="cu_othersellers" :key="'cu_othersellers'">
            <label class="weui-form-preview__label">{{customLabel.cu_othersellers || "其他业务员"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.cu_othersellers }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_dpname" :key="'cu_dpname'" v-if="form.main.cu_dpname">
            <label class="weui-form-preview__label">{{customLabel.cu_dpname || "事业部门"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.cu_dpname }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_leftamount" :key="'cu_leftamount'">
            <label class="weui-form-preview__label">{{customLabel.cu_leftamount || "应收余额(元)"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.cu_leftamount,'¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" :hidden="!form.main.cu_remark" slot="cu_remark" :key="'cu_remark'">
            <label class="weui-form-preview__label">{{customLabel.cu_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.cu_remark
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.cu_text1 || '自定义字段1'"
          v-model="form.main.cu_text1" slot="cu_text1" hidden="true" :key="'cu_text1'" v-if="form.main.cu_text1" />
          <custom-field :readOnly="true" :label="customLabel.cu_text2 || '自定义字段2'"
          v-model="form.main.cu_text2" slot="cu_text2" hidden="true" :key="'cu_text2'" v-if="form.main.cu_text2" />
          <custom-field :readOnly="true" :label="customLabel.cu_text3 || '自定义字段3'"
          v-model="form.main.cu_text3" slot="cu_text3" hidden="true" :key="'cu_text3'" v-if="form.main.cu_text3" />
          <custom-field :readOnly="true" :label="customLabel.cu_text4 || '自定义字段4'"
          v-model="form.main.cu_text4" slot="cu_text4" hidden="true" :key="'cu_text4'" v-if="form.main.cu_text4" />
          <custom-field :readOnly="true" :label="customLabel.cu_text5 || '自定义字段5'"
          v-model="form.main.cu_text5" slot="cu_text5" hidden="true" :key="'cu_text5'" v-if="form.main.cu_text5" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.items1 && form.items1.length">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="cc_name">
              <label class="weui-form-preview__label">{{customLabel.cc_name || "客户联系人"}}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cc_name }} {{ item.cc_tel }}
                <call-mobile :mobile="item.cc_tel"></call-mobile>
              </span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.cc_text1 || '自定义字段1'"
            v-model="item.cc_text1" slot="cc_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.cc_text2 || '自定义字段2'"
            v-model="item.cc_text2" slot="cc_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.cc_text3 || '自定义字段3'"
            v-model="item.cc_text3" slot="cc_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.cc_text4 || '自定义字段4'"
            v-model="item.cc_text4" slot="cc_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.cc_text5 || '自定义字段5'"
            v-model="item.cc_text5" slot="cc_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.items2 && form.items2.length">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-form-preview__item" slot="ca_address">
              <label class="weui-form-preview__label">{{customLabel.ca_address || "送货地址"}}</label>
              <span
                class="weui-form-preview__value"
                :class="{ 'weui-form-preview__value-icon': !!item.ca_address }"
              >
                {{ item.ca_address }}
                <router-link
                  v-if="item.ca_address"
                  class="iconfont icon-map"
                  :to="'/map/baidu?keywords=' + item.ca_address"
                ></router-link>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="ca_person">
              <label class="weui-form-preview__label">{{customLabel.ca_person || "联系人"}}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.ca_person }} {{ item.ca_phone }}
                <call-mobile :mobile="item.ca_phone"></call-mobile>
              </span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.ca_text1 || '自定义字段1'"
            v-model="item.ca_text1" slot="ca_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ca_text2 || '自定义字段2'"
            v-model="item.ca_text2" slot="ca_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ca_text3 || '自定义字段3'"
            v-model="item.ca_text3" slot="ca_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ca_text4 || '自定义字段4'"
            v-model="item.ca_text4" slot="ca_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ca_text5 || '自定义字段5'"
            v-model="item.ca_text5" slot="ca_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>
      <file-list v-model="form.main.cu_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/ent/information?name=' + form.main.cu_name"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >工商信息</router-link
      >
      <router-link
        :to="'/ent/operatingRisk?name=' + form.main.cu_name"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >经营风险</router-link
      >
      <router-link
        :to="'/document/customer_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <router-link
        :to="'/document/customer_change_edit?id=' + form.main.id"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >变更</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/document/customer",
      codeField: "cu_code",
      statusField: "cu_audit_status_code",
      caller: "Customer",
      xtype: "document-customer-formpanel",
      form: {
        main: {},
        items1: [],
        items2: [],
      },
    };
  },
  methods: {
    applyTempCredit() {
      var me = this, main = me.form.main;
      me.$router.push({
        name: "CustomerTempCreditEdit",
        params: {
          initData: {
            main: {
              ctc_cuid: main.id,
              ctc_cucode: main.cu_code,
              ctc_cuname: main.cu_name,
              ctc_credit: main.cu_credit || 0,
              ctc_credit_temp: 0,
              ctc_credit_sum: main.cu_credit || 0,
              ctc_status: '未审核',
              ctc_statuscode: 'UNAUDITED'
            }
          },
        },
      });
    }
  }
};
</script>